import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.7.4_sass@1.69.0/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}